import React, { useState, useEffect } from 'react';
import { NavbarTop } from '../common_components/navbar_top';
import { ConnectAndBook } from '../common_components/connect_and_book';
import { LinkUITealBoldUnderlined } from '../common_components/common_links';


function AboutMockGym() {
    const base_img_url="https://public-items-1.s3.ap-south-1.amazonaws.com/mockgym/why-mockgym/"
    const reasons =[
     { title: "For each question, it guides you on which features to discuss "+
      " and more importantly which ones to leave out of discussion.", 
      thumbnailUrl: "core-features-3-sm-60-80.jpg",
      description: ""
     }, 
     { title: "It also teaches you which design patterns and data structures are "+
      " optimal for solving specific parts of the given question and how are they used.", 
      thumbnailUrl: "design-patterns-4-sm-60-80.jpg",
      description: ""
     }, 
     { title: "For multi-threading discussions, it will train you to place the locks "+
      " on data structures/methods  such that number of parallel threads is optimal. <br /> <br /> Also it teaches you where to use lock free "+
      " data structures like ConcurrentHashMap, AtomicInteger, ConcurrentLinkedDeque etc.", 
      thumbnailUrl: "multi-threading-4-sm-60-80.jpg",
      description: ""
     }, 
     { title: "You can talk out loud your solution, just like you do in a real interview.", 
      thumbnailUrl: "why-mockgym-speak-out-loud-1-sm-60-80.jpg",
      description: ""
     },
     { title: "AI coach asks counter questions "+ 
        "and follow up questions based on solution you gave.", 
      thumbnailUrl: "why-mockgym-counter-questions-1-sm-60-80.jpg",
      description: ""
     },
     { title: "You practice with questions sets from actual interview rounds "+
        " in Amazon, Microsoft, Uber and other companies.", 
      thumbnailUrl: "why-mockgym-amazon-ms-uber-logo-2-sm-60-80.jpg",
      description: ""
     },
     { title: "Its cheaper (USD 1 per interview) and is available 24x7", 
      thumbnailUrl: "why-mockgym-available-24-7-1-sm-60-80.jpg",
      description: ""
     },
     { title: "You no longer have to struggle to find a mock interview partner "+
        " or coordinate schedules, timezones and availability with anyone.", 
      thumbnailUrl: "why-mockgym-find-buddy-1-sm-60-80.jpg",
      description: ""
     },
     { title: "After each interview practice, your evaluation report is created "+
        " which tells whether you would have cleared the interview, "+
        " how you did overall and things you can improve on.", 
      thumbnailUrl: "why-mockgym-evaluation-report-1-sm-60-80.jpg",
      description: ""
     },
     { title: "", 
      thumbnailUrl: "",
      description: ""
     }
  ]

    return (
      <div>
        <NavbarTop />
        <div className='pt-20 bg-gray-100'></div>
        <div className="bg-gray-100">
      <div className="flex flex-col justify-center items-center 
      mx-auto py-8 px-4">
       <br /><br />
       {<h1 className="text-3xl font-bold text-center mb-8">
          Why you should practice with MockGym's AI Coach ??
        </h1>
      }
       { false && <h1 className="text-3xl font-bold text-center mb-8">
          Why you should practice with MockGym's AI Interviewer ??
        </h1>
      }
        <div className="prose max-w-none text-xl font-mono">
          <p className="mb-4">
            We already have platforms for machine coding practice. <br />
            For DS & Algo we have {LinkUITealBoldUnderlined({
                url: "https://leetcode.com/", text:"LeetCode,"})} 
                for Low Level Design practice we have {LinkUITealBoldUnderlined({
                url: "https://codezym.com/", text:"CodeZym"})}
            {
              /*
            CodeZym is a platform to practice machine coding of object-oriented design
             interview questions in a multi-threaded environment.
            */}
          </p>
          <br />
          {
            <div>
             <p> I built MockGym's AI coach to fill the gap between 
            machine coding practice and real interview experience. </p> 
            For Low Level Design Interviews, the biggest hurdle most candidates face is - 
              <p className='italic text-gray-800 font-bold '>
                How to explain design of such large systems without running out of time in a 45-minute interview ??
              </p>
              MockGym's AI Coach trains you to keep your explanation
               short and concise without loosing important details.
              </div>
          }
         {false &&
          <p>I built MockGym's AI interviewer to fill the gap between 
            machine coding practice and real interview experience. <br />
             Here is how it helps you prepare better for interviews.  </p> 
             }
             <br />

          

           {/* -----------  reasons row started ---------------- */}
     <div className="mx-auto max-w-6xl  px-4 py-4 mb-12">
      {reasons
      .filter((row) => row.title)
      .map((item, i) => {
        const even = i % 2 === 0;          // alternate rows
        return (
          <article
            key={i}
            className={`flex flex-col items-center gap-8 md:flex-row ${
              even ? "" : "md:flex-row-reverse"
            }`}
          >
            {/* thumbnail */}
          { item.thumbnailUrl && <img
              src={base_img_url+item.thumbnailUrl}
              alt={item.title}
              className="w-full max-w-sm rounded-xl shadow-lg md:w-1/3"
            />}

            {/* text */}
           {
            <div className="md:w-2/3 flex flex-col">
              <div className="font-mono font-normal  leading-8"
              dangerouslySetInnerHTML={{ __html: item.title }}>
                
              </div>

              
               

            { false &&  <a
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-block rounded-full 
                bg-teal-600 px-5 py-2 text-sm font-medium text-white transition
                 hover:bg-blue-700"
              >
                Read article →
              </a>}

              {false && item.companies?.length > 0 && (
                <p className="mt-2 text-xs text-gray-500">
                  {item.companies.join(", ")}
                </p>
              )}
              
            </div>
            }
          </article>
        );
      })}
    </div>

      {/* ------------- reasons row ended ------------------- */}


         
        

        </div>
        
      </div>
      <ConnectAndBook />
    </div>
      </div>
    );
  }

  export {AboutMockGym};